import { Input } from 'antd'

const { TextArea } = Input

export default function TextAreaInput({
  rows,
  label,
  placeholder,
  name,
  value,
  onChange,
  error,
  style,
}) {
  return (
    <div className={`input ${style ? style : ''} ${error ? 'error' : ''}`}>
      {label && <label htmlFor={name}>{label}</label>}
      <TextArea
        rows={rows || 3}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      <small className='text-danger text-sm'>{error}</small>
    </div>
  )
}
